import { render, staticRenderFns } from "./SearchNotFoundHeader.vue?vue&type=template&id=afa8e9ea&"
import script from "./SearchNotFoundHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchNotFoundHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports